import React, { Component } from 'react';
import { Dialog, DialogTitle, Button } from 'material-ui';
import { Link } from 'react-router-dom';
import { CircularProgress } from 'material-ui/Progress';
import { withStyles } from 'material-ui/styles';
import utf8 from "utf8";

import logo from '../images/logo.png';
import vxclogo from '../images/VXC.png';
import acalogo from '../images/ACA.png';

const styles = theme => ({
  '@media print': {
    printable: {
      display: 'block'
    },
    nonPrintable: {
      display: 'none'
    }
  }
});

const nmvtisPrintStyleObject = `
      @media print{
        table{
          page-break-inside:auto
        }
        tr{
          page-break-inside:avoid;
          page-break-after:auto
        }
        thead{
          display:table-header-group
        }
        tfoot{
          display:table-footer-group
        }
        p{
          margin: 0;
        }
        #nmvtis-report .brandsection-wrapper p{
          max-width: 35em;
          margin: 0;
          padding: 0;
        }
        .row.report_brand_desc{
          min-height: 0.5em;
        }
        .vehicle-details>.section-wrapper>.col-12.mx-auto.d-md-none,
        .title-section>.titlesection-wrapper>.d-md-none{
          display: none;
        }
      }
      `;

const experianPrintStyleSheet = `
      @media print {
        #history .history-web-no-print>.historyNotes,
        #history .history-web-print>.historyNotes{
          margin: 8mm auto 0;
        }
      }`;

class PostFrame extends Component {
  combineReports = (report) => {
    let autocheckHTML = utf8.decode(atob(report.autocheckResponse));

    if (report.referenceId) {
      autocheckHTML = this.renderReferenceNumber(autocheckHTML, report.referenceId);
    }

    if (this.props.selectedReportType === 'RISK_SCORE' || this.props.selectedReportType === 'RISK_PLUS' ) {
      autocheckHTML = this.renderRiskPlusScore(autocheckHTML);
    }

    if (this.props.selectedReportType === 'PHYSICAL_DAMAGE_PLUS' ) {
      autocheckHTML = this.renderPhysicalDamagePlusScore(autocheckHTML);
    }

    if (this.props.selectedReportType === 'ALL_COVERAGE_PLUS' ) {
      autocheckHTML = this.renderAllCoverageScorePlusScore(autocheckHTML);
    }

    if (this.props.selectedReportType === 'VEHICLE_HISTORY') {
      const fullHistoryHtml = new DOMParser().parseFromString(autocheckHTML, 'text/html');
      const printStyleElement = document.createElement('style');
      printStyleElement.innerHTML = experianPrintStyleSheet;
      fullHistoryHtml.head.appendChild(printStyleElement);
      autocheckHTML = fullHistoryHtml.children[0].innerHTML;
    }

    return autocheckHTML;
  }

  renderReferenceNumber = (autocheckHTML, referenceId) => {
    if (autocheckHTML.includes('NMVTIS Title History Reports')) {
      autocheckHTML = autocheckHTML.replace(
        '<h4>NMVTIS Title History Reports</h4><br/>',
        `<p><strong>Reference Number:</strong> ${referenceId}</p>`
      );
    } else {
      autocheckHTML = autocheckHTML.replace(
        '<p class="rundate">',
        `<p class="rundate"><div><h4>Reference Number: ${decodeURIComponent(referenceId)}</h4></div>`
      );
    }

    return autocheckHTML;
  }

  // create the risk predictor score div
  // will be called in two places:
  // 1) if the selection is just risk predictor or 2) if it's risk score (ultimately producing two different outcomes)
  riskPredictorDiv = () => {
    const { vehicleRiskResults } = this.props.scoreReport.report;

    const riskPredictorScore = (
      `<div align="center" style="font-family: helvetica;">
        <img src=${logo} width="170" alt="Red Mountain Technologies" />
        <br />
        <h2>Red Mountain Technologies&#39; Risk Predictor Score</h2>
        <p>Reference Number: ${vehicleRiskResults[0].referenceNumber ? vehicleRiskResults[0].referenceNumber : ''}</p>
        <p>VIN: ${vehicleRiskResults[0].vin}</p>
        <p>Risk Predictor Score: <b>${vehicleRiskResults[0].results}</b></p>
      </div>`
    );

    return riskPredictorScore;
  };

  renderRiskPredictorScore = () => {
    let riskScore = '';

    if (!this.props.scoreReport.fetching) {
      riskScore = this.riskPredictorDiv();
    }

    const predictorReportHTML = (
      `<!DOCTYPE html>
        <html lang="en">
        <head>
          <meta charSet="utf-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
          <meta name="theme-color" content="#000000" />
          <title>Risk Predictor Score</title>
        </head>
        <body>
          <div id="risk-score-container" class="risk-score-container">
            ${riskScore}
          </div>
        </body>
      </html>`
    );

    return predictorReportHTML;
  }

  renderPhysicalDamage = () => {
    const { vehicleRiskResults } = this.props.physicalDamage.report;
    const summaryInfo = this.props.showSummary === 'Yes' && vehicleRiskResults[0].thinFile ? `<p>
      <span>Total Records: <b>${vehicleRiskResults[0].thinFile.activityCodes}</b></span>&#44;
      <span>Total Odometers: <b>${vehicleRiskResults[0].thinFile.odometerReadings}</b></span>&#44;
      <span>Impacted Records: <b>${vehicleRiskResults[0].thinFile.modelingActivityCodes}</b></span>
    </p>` : '<div/>';
    const results = vehicleRiskResults[0].results ?
        vehicleRiskResults[0].results : vehicleRiskResults[0].score.physicalDamage;
    const physicalDamageReportHTML = (
      `<!DOCTYPE html>
        <html lang="en">
        <head>
          <meta charSet="utf-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
          <meta name="theme-color" content="#000000" />
          <title>Risk Predictor Score</title>
        </head>
        <body>
          <div id="risk-score-container" class="risk-score-container">
            <div align="center" style="font-family: helvetica;">
              <img src=${logo} width="170" alt="Red Mountain Technologies" />
              <p />
              <h2>Red Mountain Technologies&#39; Physical Damage Score</h2>
              <p>Reference Number: ${vehicleRiskResults[0].referenceNumber}</p>
              <p>VIN: ${vehicleRiskResults[0].vin}</p>
              <p>Results: <b>${results}</b></p>
              ${summaryInfo}
            </div>
          </div>
        </body>
      </html>`
    );

    return physicalDamageReportHTML;
  }

  renderAllCoverageScore = (reportHTML) => {
    const { vehicleRiskResults } = this.props.allCoverage.report;
    const summaryInfo = this.props.showSummary === 'Yes' && vehicleRiskResults[0].thinFile ? `<p>
      <span>Total Records: <b>${vehicleRiskResults[0].thinFile.activityCodes}</b></span>&#44;
      <span>Total Odometers: <b>${vehicleRiskResults[0].thinFile.odometerReadings}</b></span>&#44;
      <span>Impacted Records: <b>${vehicleRiskResults[0].thinFile.modelingActivityCodes}</b></span>
    </p>` : '<div/>';
    const results = vehicleRiskResults[0].results ?
        vehicleRiskResults[0].results : vehicleRiskResults[0].score.allCoverage;
    const allCoverageScoreReportHTML = (
        `<!DOCTYPE html>
        <html lang="en">
        <head>
          <meta charSet="utf-8" />
          <meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no" />
          <meta name="theme-color" content="#000000" />
          <title>Risk Predictor Score</title>
        </head>
        <body>
          <div id="all-coverage-score-container" class="all-coverage-score-container">
            <div align="center" style="font-family: helvetica;">
              <img src=${logo} width="170" alt="Red Mountain Technologies" />
              <p />
              <h2>Red Mountain Technologies&#39; All Coverage Score</h2>
              <p>Reference Number: ${vehicleRiskResults[0].referenceNumber}</p>
              <p>VIN: ${vehicleRiskResults[0].vin}</p>
              <p>Results: <b>${results}</b></p>
              ${summaryInfo}
            </div>
          </div>
        </body>
      </html>`
    );

    return allCoverageScoreReportHTML;
  }

  // get the risk predictor score
  // combine with experian html
  // return combined html
  renderRiskPlusScore = (reportHTML) => {
    let riskScore = '';

    if (!this.props.scoreReport.fetching) {
      riskScore = this.riskPredictorDiv();
    }

    reportHTML = reportHTML.replace(
      '<body id="fastLinkFullReport">', `<body id="fastLinkFullReport"> ${riskScore}`
    );

    return reportHTML;
  }

  renderPhysicalDamagePlusScore = (reportHTML) => {
    let riskScore = '';

    if (!this.props.physicalDamage.fetching) {
      riskScore = this.renderPhysicalDamage();
    }

    reportHTML = reportHTML.replace('id="singleSummaryButton"',
    'id="singleSummaryButton" style="display: none"');

    reportHTML = reportHTML.replace(
      '<body id="fastLinkFullReport">', `<body id="fastLinkFullReport"> ${riskScore}`
    );

    return reportHTML;
  }

  renderAllCoverageScorePlusScore = (reportHTML) => {
    let riskScore = '';

    if (!this.props.allCoverage.fetching) {
      riskScore = this.renderAllCoverageScore();
    }

    reportHTML = reportHTML.replace('id="singleSummaryButton"',
        'id="singleSummaryButton" style="display: none"');

    reportHTML = reportHTML.replace(
        '<body id="fastLinkFullReport">', `<body id="fastLinkFullReport"> ${riskScore}`
    );

    return reportHTML;
  }

  getACAResponse = (report) => {
    return atob(report);
  };

  printFrame = (frameId) => {
    let frame = document.getElementById(frameId);

    try {
      frame.contentWindow.document.execCommand('print', false, null);
    } catch (e) {
      frame.contentWindow.print();
    }
  }

  render() {
    const iFrameNode = this.refs.myIframe;
    const { historyReport,
            nmvtisReport,
            scoreReport,
            physicalDamage,
            allCoverage,
            selectedReportType,
            classes } = this.props;

    let isLoading = true;

    let reportHtml = '';
    if (this.props.acaReport && this.props.acaReport.report && this.props.acaReport.report.reportResult) {
      reportHtml = this.getACAResponse(this.props.acaReport.report.reportResult);
    } else if(this.props.mileageReport && this.props.mileageReport.report && this.props.mileageReport.report.autocheckResponse) {
      reportHtml = this.getACAResponse(this.props.mileageReport.report.autocheckResponse);
    } else if (historyReport && historyReport.report && historyReport.report.autocheckResponse) {
      reportHtml = this.combineReports(historyReport.report);
    } else if (nmvtisReport && nmvtisReport.report && nmvtisReport.report.autocheckResponse) {
      reportHtml = this.combineReports(nmvtisReport.report);
      const nmvtisHtml = new DOMParser().parseFromString(reportHtml, 'text/html');
      const nmvtisButton = nmvtisHtml.getElementById('singleNmvtisButton');
      nmvtisButton.remove();
      const printStyleElement = document.createElement('style');
      printStyleElement.innerHTML = nmvtisPrintStyleObject;

      nmvtisHtml.head.appendChild(printStyleElement);
      reportHtml = nmvtisHtml.children[0].innerHTML;
    } else if (selectedReportType === 'RISK_SCORE' && scoreReport.report && scoreReport.report.vehicleRiskResults) {
      reportHtml = this.renderRiskPredictorScore();
    } else if (selectedReportType === 'PHYSICAL_DAMAGE' && physicalDamage.report && physicalDamage.report.vehicleRiskResults) {
      reportHtml = this.renderPhysicalDamage();
    } else if (selectedReportType === 'ALL_COVERAGE' && allCoverage.report && allCoverage.report.vehicleRiskResults) {
      reportHtml = this.renderAllCoverageScore();
    }

    if (iFrameNode) {
      const frameDoc = iFrameNode.contentWindow.document;
      frameDoc.open();
      frameDoc.write(reportHtml);
      frameDoc.close();

      isLoading = false;
    }

    let errorDivFullHistory = <div />;
    if (this.props.report && this.props.report.error) {
      errorDivFullHistory = <div>{this.props.report.error.message}</div>;
      isLoading = false;
    }

    const errorDivScore = <div />;
    if (this.props.scoreReport && this.props.scoreReport.error) {
      errorDivFullHistory = <div>{this.props.scoreReport.error.message}</div>;
      isLoading = false;
    }

    const show = this.props.displayDialog;
    const height = window.innerHeight;

    let progress = <div align="center"><CircularProgress size={75} /></div>;
    if (!isLoading) {
      progress = <div />;
    }

    return (
      <Dialog open={show} fullScreen>
        <DialogTitle className={classes.nonPrintable} style={{ height: '20px' }}>
          <Button style={{ float: 'right', marginTop: '30px', marginRight: '30px' }} variant="raised" color="primary" onClick={o => this.props.hideModal()}>Close</Button>
          <Button style={{ float: 'right', marginTop: '30px', marginRight: '30px' }} variant="raised" color="primary" onClick={o => this.printFrame('experian')}>Print</Button>
        </DialogTitle>
        <div className={classes.printable}>
          {errorDivFullHistory}
          {errorDivScore}
          {progress}
          <div style={{ display: 'flex', justifyContent: 'center'}}>
          <iframe
            frameBorder={0}
            id="experian"
            title="experian"
            ref="myIframe"
            src=""
            style={{
              position: 'relative',
              top: 0,
              right: 0,
              bottom: 0,
              left: 0,
              margin: '1cm',
              overflow: 'scroll !important',
              border: '1px solid black',
              width: '80%'
            }}
            height={height}
            width="100%"
          />
          </div>
        </div>
      </Dialog>

    );
  }
}

export default withStyles(styles, { withTheme: true })(PostFrame);


// WEBPACK FOOTER //
// ./src/components/PostFrame.js